import CheckBox from '@uikit/components/CheckBox/CheckBox';
import clsx from 'clsx';
import type { MultiSelectCategoryItemProps } from './interfaces';
import styles from './MultiSelectCategoryItem.module.scss';

const MultiSelectCategoryItem = ({
  label,
  onClick,
  status,
  listBoxId,
  isFocus,
}: MultiSelectCategoryItemProps) => {
  return (
    <li
      onClick={onClick}
      className={clsx(styles.base)}
      id={listBoxId}
      role="option"
      aria-selected={status === 'all'}
    >
      <span
        className={clsx(styles.innerWrapper, {
          [styles.active]: status === 'all',
          [styles.focus]: isFocus,
        })}
      >
        <CheckBox
          tabIndex={-1}
          checked={status === 'all'}
          isIndeterminate={status === 'some'}
          readOnly
        />
        <span className={styles.text}>{label}</span>
      </span>
    </li>
  );
};

export default MultiSelectCategoryItem;
